import React, { PureComponent } from 'react';
import { Pagination, Table } from 'semantic-ui-react';
import { Runner, RunnerTableCol, SortDir } from '../../types';
import { getRunnerSortFunc, RunnerSortDefaults, sortDirToString } from '../../utils';
import { GlobalContext } from '../App/GlobalContext';
import { ErrorContainer } from '../Shared';
import RunnersTableRow from './RunnersTableRow';

interface Props {
  loading: boolean;
  error: boolean;
  runners: Runner[];
}

interface State {
  sortCol: RunnerTableCol;
  sortDir: SortDir;
  page: number;
}

const PAGE_SIZE = 100;

class RunnersTable extends PureComponent<Props, State> {
  public state = {
    page: 0,
    sortCol: RunnerTableCol.Name,
    sortDir: SortDir.Ascending,
  };

  public render() {
    const { loading, error, runners } = this.props;
    const { sortCol, sortDir, page } = this.state;

    if (error) {
      return <ErrorContainer />;
    }

    const sortedRunners = runners.sort(getRunnerSortFunc(sortCol, sortDir));
    const start = page * PAGE_SIZE;
    const runnersPage = sortedRunners.slice(start, start + PAGE_SIZE);
    const totalPages = Math.ceil(runners.length / PAGE_SIZE);

    return (
      <GlobalContext.Consumer>
        {({ darkMode }) => (
          <Table compact={true} sortable={true} inverted={darkMode}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  sorted={this.getSorted(RunnerTableCol.Name)}
                  onClick={this.handleSort(RunnerTableCol.Name)}
                  style={loading ? { width: '15%' } : undefined}
                >
                  Name
                </Table.HeaderCell>
                <Table.HeaderCell
                  style={{ cursor: 'auto', backgroundColor: darkMode ? 'rgba(0, 0, 0, 0.15)' : 'rgb(249, 250, 251)' }}
                >
                  Links
                </Table.HeaderCell>
                <Table.HeaderCell
                  sorted={this.getSorted(RunnerTableCol.RunCount)}
                  onClick={this.handleSort(RunnerTableCol.RunCount)}
                  style={loading ? { width: '15%' } : undefined}
                >
                  Runs
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {loading && [...Array(30)].map((_, i) => <RunnersTableRow key={`loading-row-${i}`} />)}
              {!loading && runnersPage.map(runner => <RunnersTableRow key={runner.id} runner={runner} />)}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="3" style={{ textAlign: 'center' }}>
                  <Pagination
                    activePage={page + 1}
                    totalPages={totalPages}
                    onPageChange={this.handlePageChange}
                    firstItem={null}
                    lastItem={null}
                    inverted={darkMode}
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        )}
      </GlobalContext.Consumer>
    );
  }

  private getSorted = (col: RunnerTableCol) =>
    sortDirToString(this.state.sortCol === col ? this.state.sortDir : undefined);

  private handleSort = (col: RunnerTableCol) => () => {
    const { sortCol, sortDir } = this.state;

    if (sortCol === col) {
      this.setState({
        sortDir: sortDir === SortDir.Ascending ? SortDir.Descending : SortDir.Ascending,
      });
    } else {
      this.setState({ sortCol: col, sortDir: RunnerSortDefaults[col] });
    }
  };

  private handlePageChange = (e: any, { activePage }: any) => {
    this.setState({ page: activePage - 1 });
  };
}

export default RunnersTable;
export { RunnersTable };
